import { SHOW_SNACKBAR } from "./actionTypes";
import instance from "../axios-base";
import provider from "../api-provider";
import {
  setLoader,
  unSetLoader,
  setErrorMessage,
  setSuccessModal,
} from "./appActions";
import * as actionTypes from "./actionTypes";
import getToken from "../token";
import { displayDateFormatter, fixDate } from "components/helper";
import { billing } from "store/requests";

export const getChargeEntryList = (
  payload = {},
  loader = true,
  addToStore = true,
  exporting = false,
) => {
  return async (dispatch) => {
    try {
      if (loader) {
        dispatch(setLoader());
      }
      const newPatientDetails = []; // Initialize empty array
      dispatch({ type: actionTypes.SET_PRACTICE_PATIENTS, patients: {} });
      let response = await billing({
        url: "/getChargeEntryList",
        payload,
      });
      response.data["success"].forEach((p) => {
        newPatientDetails.push({
          ...p,
          id: p.charge_entry_id,
          patient_name: p.first_name + " " + p.last_name,
          status: p.status || "",
          status_chg_prev_status: p.status_chg_prev_status || "",
          service_date: addToStore
            ? fixDate(p.service_date)
            : displayDateFormatter(p.service_date),
          dob: addToStore ? fixDate(p.dob) : displayDateFormatter(p.dob, null),
          created_dt: exporting
            ? displayDateFormatter(p.charge_entry_date)
            : fixDate(p.charge_entry_date),
          last_updated_date: exporting
            ? displayDateFormatter(p.last_updated_date)
            : fixDate(p.last_updated_date),
          last_updated_status_date: exporting
            ? displayDateFormatter(p.last_updated_status_date)
            : fixDate(p.last_updated_status_date),
          patient_service_date: addToStore
            ? fixDate(p.service_date)
            : displayDateFormatter(p.service_date),
          patient_dob: addToStore
            ? fixDate(p.dob)
            : displayDateFormatter(p.dob),
        });
      });
      console.log("newPatientDetails: ", newPatientDetails);

      if (addToStore)
        dispatch({
          type: actionTypes.SET_PRACTICE_PATIENTS,
          patients: {
            patientDetails: newPatientDetails,
            total_count: response.data.total_count,
          },
        });
      dispatch(unSetLoader());

      return newPatientDetails;
    } catch (error) {
      dispatch(
        setErrorMessage(
          error?.response?.data?.error
            ? error.response.data.error
            : error.message,
        ),
      );
      dispatch(unSetLoader());
    }
  };
};

export const patientSearch = (payload, source) => {
  return async (dispatch) => {
    try {
      let response = await billing({
        url: "/patientSearch",
        payload,
        data: {
          cancelToken: source?.token,
        },
      });
      if (response.data.success) {
        let newArr = response.data.success.map((item) => {
          const dob = displayDateFormatter(item.dob);
          const patient_name = item.first_name + " " + item.last_name;
          return {
            ...item,
            id: item.patient_id,
            patient_name,
            charge_entry_id: item.patient_id,
            status: item.status || "",
            fullText: `${patient_name} (${dob})`,
          };
        });
        newArr.sort(function (a, b) {
          if (a.patient_name < b.patient_name) {
            return -1;
          }
          if (a.patient_name > b.patient_name) {
            return 1;
          }
          return 0;
        });
        dispatch(storePatient(newArr));
        return newArr;
      }
    } catch (error) {
      console.log("ERROR", error);
    }
  };
};

export const storePatient = (val) => {
  return {
    type: actionTypes.SET_PATIENT_SEARCH,
    payload: val,
  };
};

export const statusFilter = (payload, source) => {
  return async () => {
    try {
      let response = await billing({
        url: "/statusFilter",
        payload,
        data: {
          cancelToken: source?.token,
        },
      });
      return response;
    } catch (error) {
      console.log("error statusFilter: ", error);
    }
  };
};

export const uploadChargeEntryFile = (file) => {
  const data = new FormData();
  data.append("file", file);
  data.append(
    "practice_id",
    JSON.parse(localStorage.getItem("auth_data"))["selected_practice"],
  );
  return async (dispatch, store) => {
    try {
      let response = await instance({
        url: "/bulkUpload",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${getToken()}`,
        },
        data,
      });
      if (response.status === 200) {
        dispatch(
          getChargeEntryList({
            where: { practice_id: store().auth.authData?.selected_practice },
          }),
        );
        dispatch(
          setSuccessModal({
            open: true,
            title: "Upload Successful",
            message: response?.data.success,
          }),
        );
      }
      console.log("UPLOAD DOC RESPONSE", response);
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
      console.log("ERROR", error);
    }
  };
};

export const uploadDictation = (payload) => {
  return async (dispatch) => {
    try {
      let response = await provider({
        url: `/provider/uploadDictation`,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: payload,
      });
      dispatch({
        type: SHOW_SNACKBAR,
        message: "Audio uploaded successfully",
      });
      return response.data;
    } catch (error) {
      console.log("error uploadDictation: ", error);
      dispatch({
        type: SHOW_SNACKBAR,
        message: "Failed to upload audio",
      });
      return "ERROR";
    }
  };
};

export const getDictation = async (payload) => {
  try {
    let response = await provider({
      url: `/provider/getDictation`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "arraybuffer",
      data: payload,
    });
    const mimeType = response.headers["content-type"];
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: mimeType }),
    );
    return url;
  } catch (error) {
    console.log("error getDictation: ", error);
    return "ERROR";
  }
};

export const getProviderDetails = () => {
  return async (dispatch, store) => {
    try {
      const practice_id = store().auth?.authData?.selected_practice;

      let response = await billing({
        url: "/getProviderDetails",
        payload: {
          practice_id,
        },
      });
      dispatch({
        type: actionTypes.SET_PROVIDERS,
        providers: response.data.provider.map((p) => ({
          ...p,
          provider_full_name:
            p.provider_first_name + " " + p.provider_last_name,
        })),
      });
      return response.data.provider;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const getDocumentType = () => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getDocumentType",
        payload: { type: "DocumentType" },
      });
      dispatch({
        type: actionTypes.SET_DOCUMENT_TYPE,
        types: data,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const changeDashboardFilter = (filter) => {
  return {
    type: actionTypes.CHANGE_DASHBOARD_FILTER,
    filter: filter,
  };
};

export const changeDocumentFilter = (filter) => {
  return {
    type: actionTypes.CHANGE_DOCUMENT_FILTER,
    filter: filter,
  };
};

export const changeDocumentSort = (sort) => {
  return {
    type: actionTypes.CHANGE_DOCUMENT_SORT,
    sort: sort,
  };
};

export const getClaimsNeedActionSummary = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getClaimsNeedActionSummary",
        payload,
      });
      return data.success[0];
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const getClaimsNeedActionDetails = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getClaimsNeedActionDetails",
        payload,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const getSecondaryDraftClaims = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getSecondaryDraftClaims",
        payload,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const downloadBillsZip = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/downloadBillsZip",
        payload,
        data: {
          responseType: "arraybuffer",
        },
      });
      return { data };
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const setAdvanceDocumentSearch = ({ payload, data }) => {
  return {
    type: actionTypes.SET_ADV_DOCUMENT_SEARCH,
    payload: {
      payload,
      data,
    },
  };
};

export const setPracticeLocation = (practiceLocation) => ({
  type: actionTypes.SET_PRACTICE_LOC,
  practiceLocation,
});
